import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close-circle.svg'
import _imports_1 from '../assets/edit.svg'
import _imports_2 from '../assets/code.svg'
import _imports_3 from '../assets/edit_params.svg'
import _imports_4 from '../assets/copy.svg'
import _imports_5 from '../assets/trash2.svg'


const _withScopeId = n => (_pushScopeId("data-v-1d82822b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Parameters", -1))
const _hoisted_6 = { class: "test" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "code icon"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "table" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Value"),
  /*#__PURE__*/_createElementVNode("th", null, "Action")
], -1))
const _hoisted_13 = { class: "action-container" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  height: "20",
  width: "20",
  alt: "edit param"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  height: "20",
  width: "20",
  alt: "inspect param"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  height: "20",
  width: "20",
  alt: "delete param"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "action-container" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "activeSave",
  src: _imports_3,
  height: "20",
  width: "20",
  alt: "edit param"
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "icon-button",
  disabled: ""
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    height: "20",
    width: "20",
    alt: "copy param"
  })
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "icon-button",
  disabled: ""
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    height: "20",
    width: "20",
    alt: "delete param"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShowParams)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onExitModal && _ctx.onExitModal(...args))),
              class: "icon-button"
            }, _hoisted_4),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "icon-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAddParam && _ctx.onAddParam(...args)))
              }, _hoisted_8),
              _createElementVNode("button", {
                class: "icon-button",
                onClick: _cache[2] || (_cache[2] = () => (_ctx.isInspectActive = true))
              }, _hoisted_10)
            ])
          ]),
          _createElementVNode("table", _hoisted_11, [
            _hoisted_12,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.globalStore.getNode(_ctx.ncStore.editingNodeId)!.parameters, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [
                (!_ctx.editModeParams.includes(item.id))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.type), 1),
                      _createElementVNode("td", null, _toDisplayString(item.value), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("button", {
                            class: "icon-button",
                            onClick: () => _ctx.onEditParam(item.id)
                          }, _hoisted_16, 8, _hoisted_14),
                          _createElementVNode("button", {
                            class: "icon-button",
                            onClick: () => _ctx.onDup(item)
                          }, _hoisted_19, 8, _hoisted_17),
                          _createElementVNode("button", {
                            class: "icon-button",
                            onClick: () => _ctx.onDeleteParam(item.id)
                          }, _hoisted_22, 8, _hoisted_20)
                        ])
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "editInput",
                          "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
                        }, null, 8, _hoisted_23), [
                          [_vModelText, item.name]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "editInput",
                          "onUpdate:modelValue": ($event: any) => ((item.type) = $event)
                        }, null, 8, _hoisted_24), [
                          [_vModelText, item.type]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "editInput",
                          "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                        }, null, 8, _hoisted_25), [
                          [_vModelText, item.value]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("button", {
                            class: "icon-button",
                            onClick: () => _ctx.onEditParam(item.id)
                          }, _hoisted_29, 8, _hoisted_27),
                          _hoisted_30,
                          _hoisted_31
                        ])
                      ])
                    ], 64))
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}